import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Stack, Button } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from '@mui/icons-material/Assignment';

/**
 * 規約管理のハブ画面（クーポン管理と同様のレイアウト）
 */
const TermsManagement = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ mt: 6 }}>
      <Box
        sx={{
          p: 4,
          borderRadius: 2,
          border: '2px solid #333',
          backgroundColor: '#fff',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            borderBottom: '2px solid #32c86b',
            paddingBottom: '4px',
            marginBottom: '20px',
            fontWeight: 700,
          }}
        >
          規約管理
        </Typography>

        <Typography variant="body2" sx={{ mb: 3 }}>
          ベース規約はシステム全体のデフォルトの利用規約です。プラン別規約では、各プラン専用の内容を編集できます。
        </Typography>

        <Stack spacing={2}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<DescriptionIcon />}
            onClick={() => navigate('/terms-edit/base')}
            sx={{
              borderRadius: '8px',
              py: 2,
              textTransform: 'none',
              fontWeight: 600,
              justifyContent: 'flex-start',
              px: 3,
            }}
          >
            ベース規約を編集
          </Button>
          <Button
            variant="contained"
            color="success"
            size="large"
            startIcon={<AssignmentIcon />}
            onClick={() => navigate('/terms-edit/plan')}
            sx={{
              borderRadius: '8px',
              py: 2,
              textTransform: 'none',
              fontWeight: 600,
              justifyContent: 'flex-start',
              px: 3,
            }}
          >
            プラン別規約を編集
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default TermsManagement;
